import { Typography } from '@/components/common';
import clsx from 'clsx';
import Image from 'next/image';
import React from 'react';

interface ModalHeaderProps {
	title: string | React.ReactElement;
	icon?: string;
	trailing?: React.ReactNode;
	classNameContent?: string;
	classNameImage?: string;
	classNameTitle?: string;
	classNameTrailing?: string;
}
export const ModalHeader: React.FC<ModalHeaderProps> = ({
	title,
	icon,
	trailing,
	classNameContent,
	classNameImage,
	classNameTitle,
	classNameTrailing,
}) => {
	const hasTrailing = Boolean(trailing);

	return (
		<div id="header" className="w-full relative">
			<div
				className={clsx(
					'flex w-full min-w-0 gap-2',
					hasTrailing ? 'items-start justify-between' : 'items-center',
					!hasTrailing && 'justify-start md:justify-center',
					classNameContent
				)}
			>
				<div className={clsx('flex min-w-0 flex-1 gap-2 items-center')}>
					<Image
						src={icon ?? '/logos/hat-logo.png'}
						alt=""
						width={40}
						height={40}
						className={clsx(
							'hidden !h-10 !w-10 !min-h-10 !min-w-10 shrink-0 object-contain md:block',
							classNameImage
						)}
					/>
					{typeof title === 'string' ? (
						<Typography
							type="semibold-20"
							className={clsx(
								'min-w-0 flex-1 break-words line-clamp-2',
								classNameTitle
							)}
						>
							{title}
						</Typography>
					) : (
						<div className="min-w-0 flex-1 max-w-full">{title}</div>
					)}
				</div>
				{trailing ? (
					<div
						className={clsx(
							'shrink-0 self-start pr-4 pt-0.5',
							classNameTrailing
						)}
					>
						{trailing}
					</div>
				) : null}
			</div>
		</div>
	);
};
